import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultPhraseAddInfo } from '../interfaces/PhraseIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C302PhraseAddProps {
  execPhraseAdd: (deviceId: string, phrase_text: string, opts?: { overwrite?: boolean }) => Promise<ResultPhraseAddInfo>
  loading: loadStatus
}
// C302 優先単語登録API呼出
export const useC302PhraseAdd = (): C302PhraseAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execPhraseAdd = async (deviceId: string, phrase_text: string, opts?: { overwrite?: boolean }) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      // ボディ作成
      const body = { phrase_text: phrase_text, language: 'ja', overwrite: opts?.overwrite === true,}

      const response = await axios.post(
        buildDeviceUrl(deviceId, apiUrl.phrasesPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execPhraseAdd, loading }
}
